import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserNotification } from "../../../types/Notification";
import { faChevronLeft, faChevronRight, faCircleExclamation, faExclamation } from "@fortawesome/free-solid-svg-icons";
import { Pagination } from "../../../types/PaginiationResult";
import DOMPurify from 'dompurify';
import styled from "styled-components";
import { useMemo } from "react";


interface UserNotificationTableProps {
    page: Pagination<UserNotification>;
    onPageChange: (newPage: number) => void;
    totalUnreadCount:number;
    pageSize:number;
}

const StyledSpan = styled.span`
    p {
      margin: 0;
      }
`;



const UserNotificationTable = ({ page, onPageChange, totalUnreadCount, pageSize }: UserNotificationTableProps) => {
    const { records, totalPages, page: currentPage} = page;

    const recordsNowRead = useMemo(() => {
    if(!totalUnreadCount || !pageSize) return 0;

    if(totalUnreadCount < pageSize) {
        return totalUnreadCount;
    }

    if(totalUnreadCount >= pageSize * currentPage) {
        return pageSize * currentPage;
    }

    return 0;

    }, [totalUnreadCount, page]);


    const toRead = useMemo(() => {
    return totalUnreadCount - recordsNowRead;
    }, [totalUnreadCount, recordsNowRead]);


    return(
<div className="d-flex flex-column h-100">
    <div className="flex-grow-1 overflow-auto">
{
  records.map((notification) => (
    <div 
      key={notification.notificationId} 
      className="row gx-0 p-2 p-2 mb-2 align-items-center rounded user-notification-item"
    >
      <div className="col-2 text-muted small  p-1">
        <StyledSpan>
          {notification.notificationDate.toFormat("dd/MM/yyyy")}
        </StyledSpan>
      </div>
      <div className="col-9 d-flex justify-content-between align-items-center  p-1">
        <StyledSpan 
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notification.message!) }} 
        />
      </div>
      <div className="col-1 d-flex justify-content-end p-1">
        {!notification.isRead && (
          <FontAwesomeIcon icon={faCircleExclamation} />
        )}
      </div>
    </div>
  ))
}

    </div>

            {
            currentPage !== totalPages && (
            <div className="d-flex justify-content-center align-flex-center gap-3 pt-2">
                <button className="btn btn-outline-secondary" onClick={() => onPageChange(currentPage + 1)}>
                   Load more {
                    toRead > 0 && `(${ toRead } unread)`
                   }
                </button>   
            </div>
    )
        }

</div>
    )
};

export default UserNotificationTable;